
const images = (folder, lang) => {
    let listImg = [];
    if (process.env.NODE_ENV === 'development') {
        for(let i = 0; i < 191; i++){
            listImg.push(`http://localhost:8081/media/${lang}/ccSynchronisation/cc_synchronisation_${i.toString().padStart(5, '0')}.jpg`)
        }
    } else {
        for(let i = 0; i < 191; i++){
            listImg.push(`https://www.dioptase.fr/media/${lang}/ccSynchronisation/cc_synchronisation_${i.toString().padStart(5, '0')}.jpg`)
        }
    }
    return listImg;
}
export default images;
